import { LAST_GOLD_PRICE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function PostLastGoldPrice(data){
  const api = `${LAST_GOLD_PRICE_API}`;
  return axiosHttp.post(api, data);
}
